export default __webpack_public_path__ + "static/media/ForkKnifeBlack.8ef52cd1.svg";